/************************************************************/
/******* Use for alert function to it quick and easy ********/
/************************************************************/
function alertToolBar( header, content, mode) {
	if ( mode == 'error' ) {
		$( document.createElement('div') )
		.addClass('alertTopNav alertTopNav-error')
		.append(
			$( document.createElement('div') )
			.html( '<strong>'+ header +'</strong><br />'+ content )
		)
		.appendTo('#topAlertBar')
		.slideDown()
		.delay(3000)
		.slideUp(800, function()
		{
			$(this).remove();
		});
	} else if ( mode == 'success' ) {
		$( document.createElement('div') )
		.addClass('alertTopNav alertTopNav-success')
		.append(
			$( document.createElement('div') )
			.html( '<strong>'+ header +'</strong><br />'+ content )
		)
		.appendTo('#topAlertBar')
		.slideDown()
		.delay(3000)
		.slideUp(800, function()
		{
			$(this).remove();
		});
	}
}

function strconvert( str ) {
    var ret = str;

	ret = ret.replace( /ø/g, 'oe' );
    ret = ret.replace( /Ø/g, 'OE' );
    ret = ret.replace( /å/g, 'aa' );
    ret = ret.replace( /Å/g, 'AA' );
    ret = ret.replace( /æ/g, 'ae' );
    ret = ret.replace( /Æ/g, 'AE' );
    ret = ret.replace( /\_/g, '-' );

	ret = ret.replace(/[^a-zA-Z0-9-]/ig,'-').toLowerCase();
	ret = ret.replace(/[_-]+/ig,'-');

	ret.indexOf('-') == 0 ? ret = ret.replace( '-', '' ) : ret;

	return ret;
}

// Loader can be usinn every time json have been call!
function onDocumentStart()
{
	$("a[data-toggle=modal]").click(function (e)
	{
		target = $(this).attr('data-target');
		dataTitle = $(this).attr('data-title');
		urllink = $(this).attr('href');
		$("#modalContent").load(urllink, function(){
			onDocumentStart();
		});
	});

	$('[data-toggle="popover"]').popover({
		'trigger' : 'hover',
		'container' : 'body',
		'html' : true
	});

	$('[data-toggle="popover-left"]').popover({
		'trigger' : 'hover',
		'container' : 'body',
		'html' : true,
		'placement' : 'left'
	});

	$('[data-toggle="tooltip"]').tooltip();
	$('[data-toggle="modal"]').tooltip();

	$('form.formSub').submit(function(){
		return false;
	});

	$('input.datepicker').datetimepicker({
		 format : 'YYYY-MM-DD HH:mm'
	});
}

/* Handle when document is ready */
$(function() {
	onDocumentStart();
});


$(document).bind('pull-event-getAll:ready',function() {	$.events.pull.getAll(); });
$(document).bind('pull-event-ticket-getAll:ready',function() {	$.events.ticket.pull.getAll(); });
$(document).bind('pull-event-ticket-participant-getAll:ready',function() {	$.events.ticket.participant.pull.getAll(); });
